import { Route } from 'react-router';
import type { RouteHandle } from '../../shell/AppShell';
import { CalculatorPage } from './calculator/CalculatorPage';
import { AllUnitsPage } from './list/AllUnitsPage';
import { PropertiesPage } from './list/PropertiesPage';
import { PropertyRecordPage } from './record/PropertyRecordPage';
import { UnitRecordPage } from './units/UnitRecordPage';
import { WizardPage } from './wizard/WizardPage';

/** The routes of the properties module inside the app shell (Objekte 01–08, Objekt anlegen 01–10, IR-01…03). */
export const propertiesRoutes = (
  <>
    <Route path="/properties" element={<PropertiesPage />} />
    <Route
      path="/properties/units"
      element={<AllUnitsPage />}
      handle={{ mobileTitle: 'Alle Einheiten', mobileBack: '/properties' } satisfies RouteHandle}
    />
    <Route
      path="/properties/new"
      element={<WizardPage />}
      handle={{ mobileTitle: 'Objekt anlegen', mobileBack: '/properties' } satisfies RouteHandle}
    />
    <Route
      path="/properties/:id/wizard"
      element={<WizardPage />}
      handle={{ mobileTitle: 'Objekt anlegen', mobileBack: '/properties' } satisfies RouteHandle}
    />
    <Route
      path="/properties/:id/calculator"
      element={<CalculatorPage />}
      handle={{ mobileTitle: 'Immobilienrechner', mobileBack: '/properties' } satisfies RouteHandle}
    />
    <Route
      path="/properties/:id/units/:unitId"
      element={<UnitRecordPage />}
      handle={{ mobileTitle: 'Einheit', mobileBack: '/properties' } satisfies RouteHandle}
    />
    <Route
      path="/properties/:id"
      element={<PropertyRecordPage />}
      handle={{ mobileTitle: 'Objekt', mobileBack: '/properties' } satisfies RouteHandle}
    />
  </>
);
